import * as Api from "./apiAlpha";
import * as actionTypes from "./actionTypes";
import { sendHttpRequest } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";

export function loadDocumentScoringResult(documentId, siteId) {
  return async (dispatch, getState) => {
    const key = `${documentId}-${siteId}`;
    let loading = false,
      loaded = false;
    const scoring = getState().document.scoringData[key];
    if (scoring && scoring.scoringResult) {
      loading = scoring.scoringResult.loading;
      loaded = scoring.scoringResult.loaded;
    }

    if (loading || loaded) return;

    dispatch({ type: actionTypes.LOAD_DOCUMENT_SCORING_RESULT_STARTED, id: key });
    try {
      const scoringResult = await dispatch(sendHttpRequest(Api.getDocumentScoringResult(documentId, siteId)));
      dispatch({ type: actionTypes.LOAD_DOCUMENT_SCORING_RESULT_SUCCESS, payload: scoringResult, id: key });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
